// extracted by mini-css-extract-plugin
module.exports = {"securityList":"bezpieczenstwo-danych-module--securityList--21dqu"};